import React, {Fragment, useRef, useState} from 'react';

import b_ from 'b_';

import {Menu, Popup} from 'client/common/components/lego';

import KebabMenuIcon from 'client/quicksurvey/list/components/survey-list/icons/kebab-menu.svg';
import {useCopySurvey} from 'client/common/hooks/survey';

import {SurveysGoal} from 'client/common/types';
import {SurveyState} from 'client/common/store/reducers/survey/types';

import {genSurveyLink} from 'client/common/utils/survey-link';
import {openLink} from 'client/common/utils/window';
import I18N from 'assets/i18n/brandlift-project';

import {ComponentProps} from './types';

import './survey-item-menu.css';

const i18n = I18N.list.surveyList;
const b = b_.with('survey-item-menu');

type MenuItemValue = 'edit' | 'cancelModeration' | 'pause' | 'resume' | 'copy' | 'archive';
interface MenuItem {
    value: MenuItemValue;
    content: string;
}

/* eslint-disable-next-line max-statements */
export default function SurveyItemMenu(props: ComponentProps) {
    const {
        archiveSurvey,
        cancelSurveyModeration,
        clientId,
        pauseSurvey,
        resumeSurvey,
        scrollToTop,
        sendGoals,
        slug,
        name,
        state,
        surveyType,
        onCopySurveySuccess,
        pushToSurveyList
    } = props;

    const copySurvey = useCopySurvey(slug, name, {openAfterCopy: false});

    const menuIconRef = useRef(null);
    const [isMenuVisible, setIsMenuVisible] = useState(false);

    const toggleIsMenuVisible = () => {
        setIsMenuVisible(!isMenuVisible);
    };

    const editCallback = () => {
        sendGoals([SurveysGoal.ClickSurveyCardMenuEdit]);

        const url = genSurveyLink({slug, surveyType});

        openLink(url);
    };

    const copyCallback = async () => {
        sendGoals([SurveysGoal.ClickSurveyCardMenuCopy]);
        scrollToTop();

        pushToSurveyList({
            position: 0,
            items: [{isLoading: true}]
        });

        const data = await copySurvey({
            clientId,
            // всегда копируем, чтобы не получалась NONE аудитория
            audience: true
        });

        onCopySurveySuccess(data.data);
    };

    const archiveCallback = () => {
        sendGoals([SurveysGoal.ClickSurveyCardMenuArchive]);
        archiveSurvey({slug});
    };

    const pauseCallback = () => {
        sendGoals([SurveysGoal.ClickSurveyCardMenuPause]);
        pauseSurvey({slug});
    };

    const resumeCallback = () => {
        sendGoals([SurveysGoal.ClickSurveyCardMenuResume]);
        resumeSurvey({slug});
    };

    const cancelModerationCallback = () => {
        sendGoals([SurveysGoal.ClickSurveyCardMenuCancelModeration]);
        cancelSurveyModeration({slug});
    };

    const menuItems: MenuItem[] = [{value: 'edit', content: i18n.menu.edit}];

    if (surveyType === 'PRO') {
        if (state === SurveyState.Moderation) {
            menuItems.push({value: 'cancelModeration', content: i18n.menu.cancelModeration});
        } else if (state === SurveyState.Active) {
            menuItems.push({value: 'pause', content: i18n.menu.pause});
        } else if (state === SurveyState.Paused) {
            menuItems.push({value: 'resume', content: i18n.menu.resume});
        }
    }
    menuItems.push({value: 'copy', content: i18n.menu.copy});

    if (state === SurveyState.Draft) {
        menuItems.push({value: 'archive', content: i18n.menu.archive});
    }

    const onChange = (value: MenuItemValue) => {
        if (value === 'edit') {
            editCallback();
        } else if (value === 'cancelModeration') {
            cancelModerationCallback();
        } else if (value === 'pause') {
            pauseCallback();
        } else if (value === 'resume') {
            resumeCallback();
        } else if (value === 'copy') {
            void copyCallback();
        } else if (value === 'archive') {
            archiveCallback();
        }
    };

    return (
        <Fragment>
            <div className={b('icon')} onClick={toggleIsMenuVisible} ref={menuIconRef}>
                <img src={KebabMenuIcon} alt={i18n.menu.title} />
            </div>
            <Popup
                className={b('popup')}
                visible={isMenuVisible}
                target='anchor'
                anchor={menuIconRef}
                direction={['top-end']}
                onClose={toggleIsMenuVisible}
                view='default'
            >
                <Menu
                    view='dark'
                    size='m'
                    items={menuItems}
                    onChange={event => onChange(event.target.value)}
                />
            </Popup>
        </Fragment>
    );
}
